import { render, staticRenderFns } from "./nav-app.vue?vue&type=template&id=5340995d"
import script from "./nav-app.vue?vue&type=script&lang=js"
export * from "./nav-app.vue?vue&type=script&lang=js"
import style0 from "./nav-app.vue?vue&type=style&index=0&id=5340995d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports